module.exports = __webpack_public_path__ + "static/media/tawuniya-HQ1.53db5fb5.png";